@for (item of rowsArray; track $index) {
<div class="h-16 w-full bg-slate-300 animate-pulse flex rounded mb-1">
</div>
}